import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export const useCurrencySymbol = () => {
  const intl = useIntl();

  const getCurrencySymbol = useCallback(
    (currencyCode = 'USD'): string => {
      const parts = intl.formatNumberToParts(1, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol', // can also use 'symbol'
      });

      return parts.find(p => p.type === 'currency')?.value || currencyCode;
    },
    [intl],
  );

  const formatCurrency = useCallback(
    (amount: number, currencyCode = 'USD', { exact = false } = {}) => {
      return intl.formatNumber(amount, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: exact ? 2 : 0,
        maximumFractionDigits: 2,
      });
    },
    [intl],
  );

  return { getCurrencySymbol, formatCurrency };
};
